
$(document).ready(function(){
    // This button will increment the value
    $(document).on('click','.qtyplus',function(e){
        // Stop acting like a button
        e.preventDefault();
        // Get the field name
        fieldName = $(this).attr('data-id');
        // Get its current value
        var currentVal = parseInt($('input[name='+fieldName+']').val());
        // If is not undefined
        if (!isNaN(currentVal)) {
            // Increment
            $('input[name='+fieldName+']').val(currentVal + 1);
        } else {
            // Otherwise put a 0 there
            $('input[name='+fieldName+']').val(0);
        }
    });
    // This button will decrement the value till 0
    $(document).on('click','.qtyminus',function(e) {
        // Stop acting like a button
        e.preventDefault();
        // Get the field name
        fieldName = $(this).attr('data-id');
        // Get its current value
      //alert(fieldName);
        var currentVal = parseInt($('input[name='+fieldName+']').val());
        // If it isn't undefined or its greater than 0
        if (!isNaN(currentVal) && currentVal > 0) {
            // Decrement one
            $('input[name='+fieldName+']').val(currentVal - 1);
        } else {
            // Otherwise put a 0 there
            $('input[name='+fieldName+']').val(0);
        }
    });
});


$(document).ready(function () {


   $(document).on('click', 'a.site-header__cart,.product-form__cart-submit', function (e) {

      e.preventDefault();
      $('.cart_drawer_main').addClass('drawer-open');


   });


   $(' a.cart_drawer_close').click(function (e) {
      e.preventDefault();
      $('.cart_drawer_main').removeClass('drawer-open');


   });


   var modaln = document.getElementById('cart_drawer');
   window.onclick = function (event) {
      if (event.target == modaln) {
         $('.cart_drawer_main').removeClass('drawer-open');


      }

   }

   var currency = $('#get_currency').attr('data-value');
   $("a.site-header__cart").attr('href', '');


   $(document).on('click', '.product-form__cart-submit', function (e) {


      e.preventDefault();

      var variant_id_custom = $('#ProductSelect-product-template option:selected').val();
      var qty = $('#Quantity').val();
      var addData = {
         id: variant_id_custom,
         quantity: qty
      };


      $.ajax({
         type: 'POST',
         url: '/cart/add.js',
         dataType: 'json',
         data: addData,
         success: function (res) {
            //console.log(res);
            $.ajax({
               type: 'GET',
               url: '/cart.js',
               async: false,
               cache: false,
               dataType: 'json',
               success: function (res) {

                  //console.log(res);
                  var items = res['items'];
                  var count = res['item_count'];
                  //console.log(count);
                  var total_price = res['original_total_price'];
                  var final_price = parseFloat(total_price / 100).toFixed(2);

                  $(".cart_drawer .cart_drawer_items").empty();
                  for (i = 0; i < items.length; i++) {

 $(".cart_drawer .cart_drawer_items").append("<div class='cart_item'>" + "<div class='item_img'>" + "<a href=" + items[i]['url'] + ">" + "<img src=" + items[i]['image'] + ">" + "</a>" + "</div>" + "<h3 class='item_title'>" + "<a href=" + items[i]['url'] + ">" + items[i]['title'] + "</a>" + "<p><span></span>$" + parseFloat(Math.round(items[i]['price'] / 100)).toFixed(2) + "</p>" + "</h3>" + "<input type='hidden' name='quantity' value='"+ items[i]['quantity'] +"' class='hidden-quant' data-id='" + items[i]['id'] +"'/><input type='button' value='-' class='qtyminus' field='quantity' data-id='" + items[i]['id'] +"'/><input type='text' name='quantity' value='"+ items[i]['quantity'] +"' class='cart-quant qty' data-id='" + items[i]['id'] +"'/><input type='button' value='+' class='qtyplus' field='quantity' data-id='" + items[i]['id'] +"'/><input class='cart-variant' type='hidden' value=" + items[i]['id'] + ">" + "</div>");                  
                  }
                  $(".cart_drawer .cart_price h3").empty();
                  $(".cart_drawer .cart_price h3").append("<p>$" + final_price + "</p>");
                  $('.site-header__cart-indicator').empty();
                  $('.site-header__cart-indicator').html(count);
					 if(count == 0 ){
                      $('.cart_drawer_btns,.cart_total_price').css('display','none'); 
                       $('.empty_cart').css('display','block');
                    }
                 else{
                 $('.cart_drawer_btns,.cart_total_price').css('display','block'); 
                   $('.empty_cart').css('display','none');
                 }
               }
            });

         }


      });

   });


   $.ajax({
      type: 'GET',
      url: '/cart.js',
      async: false,
      cache: false,
      dataType: 'json',
      success: function (res) {

         //console.log(res);
         var items = res['items'];
         var count = res['item_count'];
         //console.log(count);
         var total_price = res['original_total_price'];
         var final_price = parseFloat(total_price / 100).toFixed(2);

         $(".cart_drawer .cart_drawer_items").empty();
         for (i = 0; i < items.length; i++) {

 $(".cart_drawer .cart_drawer_items").append("<div class='cart_item'>" + "<div class='item_img'>" + "<a href=" + items[i]['url'] + ">" + "<img src=" + items[i]['image'] + ">" + "</a>" + "</div>" + "<h3 class='item_title'>" + "<a href=" + items[i]['url'] + ">" + items[i]['title'] + "</a>" + "<p><span></span>$" + parseFloat(Math.round(items[i]['price'] / 100)).toFixed(2) + "</p>" + "</h3>" + "<input type='hidden' name='quantity' value='"+ items[i]['quantity'] +"' class='hidden-quant' data-id='" + items[i]['id'] +"'/><input type='button' value='-' class='qtyminus' field='quantity' data-id='" + items[i]['id'] +"'/><input type='text' name='quantity' value='"+ items[i]['quantity'] +"' class='cart-quant qty' data-id='" + items[i]['id'] +"'/><input type='button' value='+' class='qtyplus' field='quantity' data-id='" + items[i]['id'] +"'/><input class='cart-variant' type='hidden' value=" + items[i]['id'] + ">" + "</div>");         }
         $(".cart_drawer .cart_price h3").empty();
         $(".cart_drawer .cart_price h3").append("<p>$" + final_price + "</p>");
         $('.site-header__cart-indicator').empty();
         $('.site-header__cart-indicator').html(count);
        if(count == 0 ){
            $('.cart_drawer_btns,.cart_total_price').css('display','none'); 
            $('.empty_cart').css('display','block');
          }
         else{
                 $('.cart_drawer_btns,.cart_total_price').css('display','block'); 
           $('.empty_cart').css('display','none');
                 }
        	
      }
   });


   $(document).on('change', '.cart-quant', function () {


      var qty = $(this).val();
      //   alert(qty);
      var variant_id_custom = $(this).attr('data-id');;
  //  alert(variant_id_custom);

      if (qty == 0) {
         $(this).parent().remove();
      }

      var changeData = {
         id: variant_id_custom,
         quantity: qty
      };


      $.ajax({
         type: 'post',
         url: '/cart/change.js',
         data: changeData,
         success: function (d) {
            var count = d['item_count'];
             var total_price = d['original_total_price'];
           var final_price = parseFloat(total_price / 100).toFixed(2);
            $(".cart_drawer .cart_price h3").empty();
            $(".cart_drawer .cart_price h3").append("<p>$" + final_price + "</p>");
            $('.site-header__cart-indicator').empty();
            $('.site-header__cart-indicator').html(count);
            if(count == 0 ){
            $('.cart_drawer_btns,.cart_total_price').css('display','none'); 
            $('.empty_cart').css('display','block');
          }
            else{
                 $('.cart_drawer_btns,.cart_total_price').css('display','block'); 
              $('.empty_cart').css('display','none');
                 }
         },
         dataType: 'json'
      });


   });

  
  /****** Drawer update *************/
  function qty_adjust(variantid, qty, api_url) {
   var addData = {
      id: variantid,
      quantity: qty
   };
   $.ajax({
      type: 'POST',
      url: api_url,
      dataType: 'json',
      async: false,
      cache: false,
      data: addData,
      success: function (up_res) {
         var price = up_res['final_line_price'];
         console.log(up_res);
         $.ajax({
            type: 'GET',
            url: '/cart.js',
            cache: false,
            async: false,
            dataType: 'json',
            success: function (res) {
              //console.log(res);
         var items = res['items'];
         var count = res['item_count'];
         //console.log(count);
         var total_price = res['original_total_price'];
         var final_price = parseFloat(Math.round(total_price / 100)).toFixed(2);

         $(".cart_drawer .cart_drawer_items").empty();
         for (i = 0; i < items.length; i++) {

 $(".cart_drawer .cart_drawer_items").append("<div class='cart_item'>" + "<div class='item_img'>" + "<a href=" + items[i]['url'] + ">" + "<img src=" + items[i]['image'] + ">" + "</a>" + "</div>" + "<h3 class='item_title'>" + "<a href=" + items[i]['url'] + ">" + items[i]['title'] + "</a>" + "<p><span></span>$" + parseFloat(Math.round(items[i]['price'] / 100)).toFixed(2) + "</p>" + "</h3>" + "<input type='hidden' name='quantity' value='"+ items[i]['quantity'] +"' class='hidden-quant' data-id='" + items[i]['id'] +"'/><input type='button' value='-' class='qtyminus' field='quantity' data-id='" + items[i]['id'] +"'/><input type='text' name='quantity' value='"+ items[i]['quantity'] +"' class='cart-quant qty' data-id='" + items[i]['id'] +"'/><input type='button' value='+' class='qtyplus' field='quantity' data-id='" + items[i]['id'] +"'/><input class='cart-variant' type='hidden' value=" + items[i]['id'] + ">" + "</div>");         }
         $(".cart_drawer .cart_price h3").empty();
         $(".cart_drawer .cart_price h3").append("<p>$" + final_price + "</p>");
         $('.site-header__cart-indicator').empty();
         $('.site-header__cart-indicator').html(count);
              
			  if(count == 0 ){
            $('.cart_drawer_btns,.cart_total_price').css('display','none'); 
            $('.empty_cart').css('display','block');
          }
            else{
                 $('.cart_drawer_btns,.cart_total_price').css('display','block'); 
              $('.empty_cart').css('display','none');
                 }
            }
         });
      }
   });


}

$(document).on('click', '.qtyplus', function (e) {

   var variantid = $(this).attr('data-id');
  //alert(variantid);
   var qty = 1;
   var api_url = '/cart/add.js';
   qty_adjust(variantid, qty, api_url);

});


$(document).on('click', '.qtyminus', function (e) {

   var variantid = $(this).attr('data-id');
   var cust_qty = $(this).next().val();
 //alert(cust_qty);
	var qty = cust_qty - 1;
   var api_url = '/cart/change.js';
   qty_adjust(variantid, qty, api_url);

});

  

});


$(document).on('click', '.cart_drawer_btns', function (e) {
   var all_val = [];
   $('.cart_item').each(function () {
      var variant_id_custom = $(this).find('.cart-variant').val();
      var qtyminus = $(this).find('.cart-quant').val();

      var para = variant_id_custom + ":" + qtyminus;
      all_val.push(para);
   });

   window.location.href = "https://www.neflum.com/cart/" + all_val;

});


/** cart update *******/
function qty_adjust(final_variant_id, qty, api_url) {
   var addData = {
      id: final_variant_id,
      quantity: qty
   };
   $.ajax({
      type: 'POST',
      url: api_url,
      dataType: 'json',
      async: false,
      cache: false,
      data: addData,
      success: function (up_res) {
         var price = up_res['final_line_price'];
         console.log(up_res);
         $.ajax({
            type: 'GET',
            url: '/cart.js',
            cache: false,
            async: false,
            dataType: 'json',
            success: function (res) {
              //console.log(res);
         var items = res['items'];
         var count = res['item_count'];
         //console.log(count);
         var total_price = res['original_total_price'];
         var final_price = parseFloat(Math.round(total_price / 100)).toFixed(2);

         $(".cart_drawer .cart_drawer_items").empty();
         for (i = 0; i < items.length; i++) {

			 $(".cart_drawer .cart_drawer_items").append("<div class='cart_item'>" + "<div class='item_img'>" + "<a href=" + items[i]['url'] + ">" + "<img src=" + items[i]['image'] + ">" + "</a>" + "</div>" + "<h3 class='item_title'>" + "<a href=" + items[i]['url'] + ">" + items[i]['title'] + "</a>" + "<p><span></span>$" + parseFloat(Math.round(items[i]['price'] / 100)).toFixed(2) + "</p>" + "</h3>" + "<input type='hidden' name='quantity' value='"+ items[i]['quantity'] +"' class='hidden-quant' data-id='" + items[i]['id'] +"'/><input type='button' value='-' class='qtyminus' field='quantity' data-id='" + items[i]['id'] +"'/><input type='text' name='quantity' value='"+ items[i]['quantity'] +"' class='cart-quant qty' data-id='" + items[i]['id'] +"'/><input type='button' value='+' class='qtyplus' field='quantity' data-id='" + items[i]['id'] +"'/><input class='cart-variant' type='hidden' value=" + items[i]['id'] + ">" + "</div>");                  

         }
         $(".cart_drawer .cart_price h3").empty();
         $(".cart_drawer .cart_price h3").append("<p>$" + final_price + "</p>");
         $('.site-header__cart-indicator').empty();
         $('.site-header__cart-indicator').html(count);
			 
			  if(count == 0 ){
            $('.cart_drawer_btns,.cart_total_price').css('display','none'); 
            $('.empty_cart').css('display','block');
          }
            else{
                 $('.cart_drawer_btns,.cart_total_price').css('display','block'); 
              $('.empty_cart').css('display','none');
                 }
            }
         });
      }
   });


}

$(document).on('click', '.js-qty__adjust--plus', function (e) {

   var variantid = $(this).attr('data-id');
   var variant_id = variantid.split(":")[0];
   var final_variant_id = variant_id.split("_")[1];
  	
   var qty = 1;
   var api_url = '/cart/add.js';
   qty_adjust(final_variant_id, qty, api_url);

});


$(document).on('click', '.js-qty__adjust--minus', function (e) {

   var variantid = $(this).attr('data-id');
   var variant_id = variantid.split(":")[0];
   var final_variant_id = variant_id.split("_")[1];
   var cust_qty = $(this).prev().val();
  if(cust_qty > 1 )
  {
    var qty = cust_qty -  1;
  }
   var api_url = '/cart/change.js';
   qty_adjust(final_variant_id, qty, api_url);

});

$(document).on('change', '.js-qty__input', function (e) {
   //alert('changed');
   var curr_item_qty = $(this).val();
  var variantid = $(this).attr('id');
   var variant_id = variantid.split(":")[0];
   var final_variant_id = variant_id.split("_")[1];
   var qty = curr_item_qty;
   var api_url = '/cart/change.js';
   qty_adjust(final_variant_id, qty, api_url);


});